"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[86620],{

/***/ 86620:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ gallery_mobile; }
});

// EXTERNAL MODULE: ./node_modules/preact/compat/jsx-runtime.mjs + 1 modules
var jsx_runtime = __webpack_require__(97997);
// EXTERNAL MODULE: ./node_modules/preact/compat/dist/compat.module.js + 1 modules
var compat_module = __webpack_require__(11720);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/@splidejs/react-splide/dist/js/react-splide.esm.js
var react_splide_esm = __webpack_require__(67677);
// EXTERNAL MODULE: ./components/icons/light/chevron-left.svg
var chevron_left = __webpack_require__(30282);
// EXTERNAL MODULE: ./components/icons/light/chevron-right.svg
var chevron_right = __webpack_require__(14649);
// EXTERNAL MODULE: ./node_modules/@splidejs/react-splide/dist/css/splide-core.min.css
var splide_core_min = __webpack_require__(17793);
;// CONCATENATED MODULE: ./components/molecules/gallery-mobile/GalleryMobile.tsx







const ARROWS = "rounded-full bg-neutrals-0 hover:bg-primary-100 text-neutrals-900 p-2 disabled:opacity-60 disabled:hover:bg-neutrals-0";
const GalleryMobile = (param)=>{
    let { className ="" , classNameSlide ="" , breakpoints , perPage , height ="300px" , type , gap =24 , images , onClick  } = param;
    const DEFUALT_PADDING = "15px";
    const adjustPadding = (splide, track, rootParent, start, last, padding)=>{
        if (padding) {
            if (start === splide.index) {
                track.style.paddingLeft = DEFUALT_PADDING;
            } else {
                track.style.paddingLeft = "".concat(padding, "px");
            }
            if (last === splide.index) {
                track.style.paddingRight = DEFUALT_PADDING;
            } else {
                track.style.paddingRight = "".concat(padding, "px");
            }
        } else {
            track.style.paddingLeft = "0";
            track.style.paddingRight = "0";
        }
    };
    const adjustAllPaddings = (splide)=>{
        const last = splide.Components.Controller.getEnd();
        const start = 0;
        const padding = splide.options.padding;
        const track = splide.Components.Elements.track;
        const root = splide.Components.Elements.root;
        const rootParent = root.parentElement;
        const breakpoints = splide.options.breakpoints;
        if (breakpoints) {
            Object.entries(breakpoints).forEach((param, index)=>{
                let [key, value] = param;
                if (window.screen.width <= parseInt(key) && (index > 0 && window.screen.width > parseInt(Object.keys(breakpoints)[index - 1]) || index === 0)) {
                    adjustPadding(splide, track, rootParent, start, last, value.padding);
                }
            });
        }
        adjustPadding(splide, track, rootParent, start, last, padding);
    };
    const options = {
        ...type && {
            type
        },
        perPage: perPage,
        ...breakpoints && {
            breakpoints
        },
        ...height && {
            height
        },
        ...gap && {
            gap
        },
        perMove: 1,
        pagination: false,
        arrows: perPage !== images.length,
        lazyLoad: true,
        classes: {
            prev: "rotate-180"
        }
    };
    var _alt;
    /**
   * Render slides.
   *
   * @return Slide nodes.
   */ const renderSlides = ()=>/*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(react_splide_esm/* SplideTrack */.Gj, {
            className: "!md:p-5",
            children: images.map((image, index)=>/*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(react_splide_esm/* SplideSlide */.jw, {
                    className: "relative w-full ".concat(classNameSlide),
                    style: {
                        height
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                        alt: (_alt = image.alt) !== null && _alt !== void 0 ? _alt : "Imagen del carrusel ".concat(index + 1),
                        src: image.src,
                        draggable: false,
                        fill: true,
                        className: "object-cover"
                    })
                }, index))
        });
    //TODO revisar contador
    const [counter, setCounter] = (0,compat_module.useState)(1);
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(react_splide_esm/* Splide */.tv, {
        options: options,
        className: "relative -mx-4 flex flex-col lg:mx-0 ".concat(className),
        hasTrack: false,
        ...onClick && {
            onClick: onClick
        },
        onMove: (splide, index)=>{
            setCounter(index + 1);
            adjustAllPaddings(splide);
        },
        onMounted: (splide)=>{
            setCounter(1);
            adjustAllPaddings(splide);
        },
        children: [
            renderSlides(),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                className: "splide__arrows",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("button", {
                        className: "splide__arrows splide__arrow--prev ".concat(ARROWS, " absolute top-1/2 left-4 -translate-y-1/2"),
                        type: "button",
                        role: "tab",
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(chevron_left["default"], {
                            width: 24,
                            height: 24
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("button", {
                        className: "splide__arrows splide__arrow--next ".concat(ARROWS, " absolute top-1/2 right-4 -translate-y-1/2 "),
                        type: "button",
                        role: "tab",
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(chevron_right["default"], {
                            width: 24,
                            height: 24
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                className: "min-w-10 min-h-8 text-body text-body--xs absolute bottom-2 left-2 rounded-full bg-neutrals-900 bg-opacity-40 p-2 font-bold text-neutrals-0",
                children: [
                    counter,
                    "/",
                    images.length
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/molecules/gallery-mobile/index.ts

/* harmony default export */ var gallery_mobile = (GalleryMobile);


/***/ })

}]);